<template>
  <el-dialog width="600px" class="hx-to-create-template" :title="title" :visible.sync="dialogVisible" @close="resetDialogForm" :close-on-click-modal="false" :show-close="false">
    <div>
      <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="140px">
        <el-form-item label="供应点名称 ：" prop="title">
          <el-input v-model="itemParams.title" size="small" placeholder="请输入供应点名称"> </el-input>
        </el-form-item>

        <el-form-item label="供应点区域 ：" prop="title">
          <areaCascader v-model="areaValues" :checkStrictly="false" @changeFull="handleAreaValues" />
        </el-form-item>

        <el-form-item label="联系人姓名 ：" prop="contactName">
          <el-input v-model="itemParams.contactName" size="small" placeholder="请输入联系人姓名"> </el-input>
        </el-form-item>

        <el-form-item label="联系人手机号 ：" prop="contactMobile">
          <el-input v-model="itemParams.contactMobile" size="small" placeholder="请输入联系人手机号"> </el-input>
        </el-form-item>

        <el-form-item label="详细地址 ：" prop="detailInfo">
          <el-input v-model="itemParams.detailInfo" size="small" placeholder="请输入详细地址"> </el-input>
        </el-form-item>

        <el-form-item label="供应点地址 ：">
          <p>{{ getAdress }}</p>
        </el-form-item>

        <el-form-item>
          <el-button :disabled="isDisabled" size="small" type="primary" @click="saveSupplyCentre('dialogForm')"> 保 存 </el-button>

          <el-button size="small" @click="resetDialogForm"> 取 消 </el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import Vue from "vue";
const defalutFrom = {
  supplyId: "",
  title: "",
  address: "",
  contactName: "",
  contactMobile: "",
  province: "",
  provinceCode: "",
  city: "",
  cityCode: "",
  country: "",
  countryCode: "",
  detailInfo: "",
  sort: "1",
};
export default {
  props: {
    url: {
      type: String,
      default: "/logistics/insert",
    },
    supplyId: {
      type: [String, Number],
      default: "",
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "新增供应点",
    },
  },
  data() {
    var phoneValid = (rule, val, callback) => {
      const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (val == "" || val == undefined || val == null) {
        callback(new Error("请输入联系人电话号码"));
      } else {
        if (!reg.test(val) && val != "") {
          callback(new Error("请输入正确的电话号码"));
        } else {
          callback();
        }
      }
    };
    return {
      checkItemParams: {
        title: [{ required: true, message: "请输入供应点名称", trigger: "blur" }],
        address: [{ required: true, message: "请输入供应点地址", trigger: "blur" }],
        contactName: [{ required: true, message: "请输入联系人姓名", trigger: "blur" }],
        contactMobile: [{ required: true, validator: phoneValid, trigger: "blur" }],
        provinceCode: [{ required: true, message: "请选择省", trigger: "blur" }],
        cityCode: [{ required: true, message: "请选择市", trigger: "blur" }],
        countryCode: [{ required: true, message: "请选择县", trigger: "blur" }],
        detailInfo: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
      },
      itemParams: { ...defalutFrom },
      isDisabled: false,
      areaValues: [],
    };
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val && this.supplyId) {
          this.loadFormData();
        }
      },
    },
  },
  computed: {
    getAdress() {
      return (this.itemParams.province || "") + (this.itemParams.city || "") + (this.itemParams.country || "") + (this.itemParams.town || "") + (this.itemParams.detailInfo || "") || "";
    },
  },
  methods: {
    /**
     * 初始化表单
     */
    loadFormData() {
      Vue.ajaxGet(this, global.apiUrl + "/logistics/detail", {
        id: this.supplyId,
      }).then(res => {
        this.itemParams = res;
        this.areaValues = [res.provinceCode, res.cityCode, res.countryCode];
      });
    },
    /**
     *
     */
    handleAreaValues(data) {
      this.itemParams.province = data.labels[0];
      this.itemParams.city = data.labels[1];
      this.itemParams.country = data.labels[2];
      this.itemParams.provinceCode = data.values[0];
      this.itemParams.cityCode = data.values[1];
      this.itemParams.countryCode = data.values[2];
      if (data.labels[3]) {
        this.itemParams.town = data.labels[3];
        this.itemParams.townCode = data.values[3];
      }
    },
    /**
     * 保存新增或修改
     * @param name
     */
    saveSupplyCentre(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (!this.itemParams.town) {
            delete this.itemParams.town;
            delete this.itemParams.townCode;
          }
          this.itemParams.supplyId = parseInt(this.$route.params.supplyId);
          this.$http({
            url: global.apiUrl + this.url,
            method: this.supplyId ? "PUT" : "POST",
            body: this.itemParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.isDisabled = false;
                this.$emit("reload");
                this.resetDialogForm();
                this.$message.success(res.body.info);
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.itemParams = { ...defalutFrom };
      this.areaValues = [];
      this.$emit("update:dialogVisible", false);
    },
  },
};
</script>

<style></style>
